import { Component, Vue, Watch } from 'vue-property-decorator';
import { isEqual } from 'lodash';

import AnalysisStep from '@/components/analysis/steps/AnalysisStep.vue';
import ElementBgIcon from '@/components/elements/ElementBgIcon.vue';

import { Step, StepsKeys } from '@/plugins/podolib/services/analysis';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TStation } from '@/plugins/podolib/services/entities/EntityStations';

export type StepStation = {
  stationId: TEntity<TStation>['_id'] | null;
};

@Component({
  components: {
    AnalysisStep,
    ElementBgIcon,
  },
})
export default class AnalysisStepStation extends Vue {
  // Main data payload
  data: Step<StepStation> = null!;

  // -------------------------------------------------------------------------------------------------------------------

  /**
   * Get manifest entry
   */
  get stepStation() {
    return this.$pdc.analysis!.getManifestEntry(StepsKeys.Station);
  }

  /**
   * Get 'stations' entity
   */
  get stations() {
    return this.$pdc.analysis!.entityStations;
  }

  /**
   * Get if selected station is online
   */
  get selectedStationIsOnline() {
    return this.stations?.data.find((station) => station._id === this.data.stationId)?.online;
  }

  // -------------------------------------------------------------------------------------------------------------------

  /**
   * Keep manifest up to date
   */
  @Watch('data', { deep: true })
  onDataChanged(newValue: Step<StepStation>) {
    if (!isEqual(newValue, this.stepStation)) {
      this.$pdc.analysis!.setManifestEntry(StepsKeys.Station, this.data);

      if (this.stepStation.__system.touched && this.stepStation.stationId) {
        // Analytics
        this.$pdc.analytics?.actions.trackSuccess('NewAnalysis StationSelected', {
          stationId: this.stepStation.stationId,
        });
      }
    }
  }

  /**
   * Keep local data up to date
   */
  @Watch('stepStation', { deep: true, immediate: true })
  onStepComputeChanged(newValue: Step<StepStation>) {
    if (!isEqual(newValue, this.data)) {
      this.data = { ...this.data, ...this.stepStation };
    }
  }

  // -------------------------------------------------------------------------------------------------------------------

  /**
   * Emit "next" event to the parent
   */
  next() {
    this.$emit('next');
  }

  /**
   * On created
   */
  created() {
    if (!this.selectedStationIsOnline) {
      this.data.stationId = null;
    }
  }
}
